import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Search from "../views/Search.vue";
import SearchList from "../views/SearchList.vue";
import Searching from "../views/Searching.vue";
import Bookshelf from "../views/Bookshelf.vue";
import SearchHotWord from "../views/SearchHotWord.vue";
import RankingList from "../views/RankingList.vue";
import CategoryPages from "../views/CategoryPages.vue";
import MyCenter from "../views/MyCenter.vue";
import SingleBookDetail from "../views/SingleBookDetail.vue";
import BooksList from "../views/BooksList.vue";
import CataloguePage from "../views/CataloguePage.vue";
import TextContent from "../views/TextContent.vue";


Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        path: "/search",
        name: "search",
        component: Search,
        children: [
            {
                path: "/",
                component: SearchList
            },
            {
                path: "/Searching",
                name: "搜索",
                component: Searching
            },
            {
                path: "/Searchhotword",
                component: SearchHotWord
            },
            {
                path: "/singlebookdetail",
                name: "书籍详情",
                component: SingleBookDetail
            }
        ]
    },
    {
        path: "/bookshelf",
        name: "我的书架",
        component: Bookshelf
    },
    {
        path: "/rankinglist",
        name: "排行榜",
        component: RankingList
    },
    {
        path: "/categorypages",
        name: "分类",
        component: CategoryPages
    },
    {
        path: "/mycenter",
        name: "登录",
        component: MyCenter
    },
    {
        path: "/bookslist",
        name: "书单",
        component: BooksList
    },
    {
        path: "/cataloguepage",
        name: "目录",
        component: CataloguePage
    },
    {
        path: "/textcontent",
        name: "正文",
        component: TextContent
    }
];

const router = new VueRouter({
    routes
});

export default router;
